import React from 'react'
import { ProductName } from '@chegg-wt/core/types/site'
import * as Styled from './styled'

const CHEGG_ACCOUNT_ADDRESS = 'https://www.chegg.com/my/account'

interface SubscriptionInfoProps {
  siteName: ProductName
  tag: string
}

const SubscriptionInfo: React.FunctionComponent<SubscriptionInfoProps> = ({
  siteName,
  tag,
}) => (
  <>
    <Styled.Notice>
      Your {siteName}
      {tag} account is now a part of Chegg!
    </Styled.Notice>
    <Styled.Message>
      To manage your subscription, update your profile, or to update your payments please
      visit the &apos;My Account&apos; page on Chegg. You may be asked to log in again for
      security reasons.
    </Styled.Message>
    <Styled.Button href={CHEGG_ACCOUNT_ADDRESS} target="_blank">
      Go to Chegg
    </Styled.Button>
  </>
)

export default SubscriptionInfo
